import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";
import { Meeting } from "@app/models/rest/meeting";
import { MeetingRestService } from "@app/services/hal/meeting-rest.service";

@Injectable({ providedIn: "root" })
export class MeetingStore extends RealTimeDataStore<Meeting> {
  constructor() {
    const meetingRestService = inject(MeetingRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(meetingRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Meeting");
  }
}
